import styled from 'styled-components';
import config from '../../../config';
import './style.scss';
import {useAuth} from '../../../contexts/UserContext';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import {useState, useEffect, useRef} from 'react';
import {useApp} from '../../../contexts/AppContext';
import moment from 'moment';

export const HeaderInner = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: space-between;
  @media ${config.layout.wide} {
    width: 730px;
    justify-content: center;
  }
`;

const LogoWrap = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  margin: 0 20px;
  flex: 0 0 auto;
  @media ${config.layout.wide} {
    align-items: flex-end;
  }
`;

export const Logo = styled.div`
  height: 46px;
  width: 113px;

  @media ${config.layout.wide} {
    height: 67px;
    width: 170px;
    //background-image: image-set(url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIYAAAA1CAMAAACz+WN4AAAAP1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACzJYIvAAAAFHRSTlMAPxDA8FAggDDQoGCQcLDg36+fNY2RK7sAAARdSURBVFjD7ZndlqMgDIAVwj+IneX9n3ULqBGC7dhzerHnbG6GYhI+EhLpdNJZ2NSInIvUD6yM2TQUVJD0gRxYasXXlIDzoJv5lEW0qlAmbf00lw9zv4ZPCeqkLAqGYizlwRnDrQllVS8xWNVdplcYujiqY140NIkSukH2RlZ3jcFM3R27xMDZbY9l7HuMOu2aNKVOftgVxoIU7zDgvO11mBNoj4btOQyjGKgIeiIYdBGHY5oVhgesCUdclFI+IscIIyAFwWhFY3GIUVYcej7P6t18D8xjgOESSSjFoAKYlS4nL4ykSUUUwdBI8Q6DhQeqWZoVdo6QdEFSDrYFRHYYGtD2HYY5K87Uzp3INFzEs8bDthisaVu/rJQqsWSF5CSe2sXSM+CKEjGwYUy/xkhdX9I0J4jEewasiIAY2DA+wdB9Vty2TVxMXR/u5YThE7abWxiY5bXLiTnOIiSLjmk/Q4wZG8YnGKHLyhbstyJq1A4Mjqt9giFrVnrvVMbeD4yEx+gTjIk3WbFNbbAHf1whdRjwYTTGvRuaLmj6AkSRHYb97GzQNxnmhDVL6V8lhQHW6w0M+g6hOZEvzqurwFiwIlWOTzHEKSvQvlwj6aIEHo3ddiHqFFGDtj/aiexBBP1NSl4eDbsvgqGk7W446RsMNIdjZPvI28vuJRADqfGEk1JEWbG+aVagT2O8ujptnbvFYGZULmrgw+Gp6xazG08kLmgZSjgijRj44gVJkVdG7fUgUbBF2hNCwqGrl0gPoB6VLce55vq2DEMsak50X1gkfgpSNegxsGz5wAdsPlgAvLwNsiJGdR82jjXoihxWJCMY47JVmwVwpRRPaE/XIg/pNxTgnKOibboC0Q9jH8SedAEaKdwLFX/ZnOygbP2lPd3yVct0QJyAG/bI67IVsbGPaEEqEEuNfiFoxcpXrZrFgS8WzGFuLq9VOhZIffFY+og78Wf/f7KM/80ieydOKe6VkC+vUy7Mr57LoDz3Kujpv/yXf1v0jIUyFDbjiE3fEh55EXdZc2nncPBFDPVOY7HbwHic/CrGHISsA8aE2idTndPlrxRbw9Jy0kGwqn3KnnZO70lUM7uPoVfjFyhbTiFyu8/HqmKXp2cP1hujs6E3izfJZe254ualefQ+clZyaJUFdxdDFxNmfrJjI1HFrWVvebGlLKDyIeGQYUKSDYaxhdgU/Txpfomx8iJPW46xb178DEReMOZnNcgm5GjkUUFADBcPC5nknbNh9x8Q9te5cdUxis+A8bm0MlX5sRxh5OqMYR9VwajneA3z/SNanaFjlLKxGVjOBq/iLzB45Fj/wpr00Hcx9nsFiA4jJ6CWbcBMjzG87XqfB3kTQ63YpDoMATkg2MrmFgNUMUxTjVlVkA5jfAMj14jMK7qBcTT1/AaYn4oKZIOhwJX7WqmRrPBj2DQnV6LB7vYNZmFNRoz2EPabozDJpEU30cgcCbxIJaYxrcmyRvUrwt4qvFP9C59pgTzce4s2AAAAAElFTkSuQmCC') 1x, url('data:image/png;base64,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') 2x);
  }
`;

const HeaderVenueNameArea = styled.div`
  flex: 1 1 auto;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  padding: 0 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media ${config.layout.wide} {
    min-width: 193px;
    max-width: 200px;
  }
`;

const HeaderBurgerButton = styled.div`
  width: 75px;
  height: 75px;
  background-color: #fff;
  flex: 0 0 auto;
  cursor: pointer;

  position: relative;

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: left 0.3s ease-out;
    background-color: #000;
  }


  .icon {
    position: absolute;
    width: 20px;
    height: 20px;
    left: 50%;
    top: 50%;
    margin-left: -10px;
    margin-top: -10px;
    mix-blend-mode: difference;

    &:before {
      content: '';
      display: block;
      width: 20px;
      height: 4px;
      background-color: #ffffff;
      position: absolute;
      top: 4px;
      left: 0;
      transform-origin: center;
      transition: transform 0.15s ease-out, top 0.15s ease-out;
    }

    &:after {
      content: '';
      display: block;
      width: 20px;
      height: 4px;
      background-color: #ffffff;
      position: absolute;
      top: calc(4px + 4px + 5px);
      left: 0;
      transform-origin: center;
      transition: transform 0.15s ease-out, top 0.15s ease-out;
    }
  }

  &.open {
    .icon {
      &:before {
        transform: rotateZ(45deg);
        top: 8.5px;
      }

      &:after {
        transform: rotateZ(-45deg);
        top: calc(4px + 4px + 5px - 2.5px - 2px);
      }
    }
  }

  @media ${config.layout.wide} {
    &:hover {
      &:before {
        left: 100%;
      }
    }
  }

`;


const LogoutButtonArea = styled.div`
  margin-top: 40px;
  text-align: center;
  @media ${config.layout.wide} {
    text-align: left;
  }
`;

const LogoutButton = styled.button`
  width: 200px;
  text-align: center;
`;

const MenuPanelElm = styled.div`
  width: 100%;
  //background-color: pink;
  background-color: #ffffff;

  &.closed {
    display: none;
  }

  min-height: calc(100vh - 75px);
`;

const PanelContents = styled.div`
  padding: 34px 20px 70px;

  @media ${config.layout.wide} {
    padding: 40px 0 70px;
    max-width: 730px;
    margin: 0 auto;
  }
`;

const VenueCode = styled.div`
  text-align: right;
  font-size: 14px;
  font-weight: bold;
  line-height: 19px;
`;

function NotLoggedInHeader() {
  return <LogoWrap className={'logo-wrap'}><Logo
      className="sitelogo header-logo static"/></LogoWrap>;
}

const VenueInfoArea = styled.div`
  margin-top: 20px;
  margin-bottom: 50px;
  border-top: 6px solid #000000;

  @media ${config.layout.wide} {
    margin-bottom: 40px;
    border-top: 1px solid #000000;
    display: flex;
    align-items: stretch;
    padding-top: 18px;
    padding-bottom: 14px;
    border-bottom: 1px solid #000000;
  }

  & > .name {
    .label {
      margin-top: 20px;
      font-size: 14px;
      font-weight: bold;
      line-height: 19px;

      @media ${config.layout.wide} {
        margin-top: 2px;
      }
    }

    .venue-name {
      margin-top: 10px;
      font-size: 30px;
      font-weight: bold;
      line-height: 36px;
      margin-bottom: 20px;
      @media ${config.layout.wide} {
        margin-top: 5px;
        margin-bottom: 10px;
      }
    }

    border-bottom: 1px solid #000000;

    @media ${config.layout.wide} {
      width: 50%;
      flex: 0 0 auto;
      border-bottom: none;
      padding-right: 15px;
    }
  }

  .care-link {
    text-decoration: none;
    color: #000000;
    height: 66px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #000000;
    position: relative;

    @media ${config.layout.wide} {
      width: 50%;
      height: auto;
      flex: 0 0 auto;
      border-bottom: none;
      border-left: 1px solid #000000;
      padding-left: 30px;
    }

    span {
      font-weight: bold;
      font-size: 20px;
      margin-left: 10px;
    }

    @media ${config.layout.wide} {
      &:hover {
        &:after {
          right: 0;
        }
      }
    }

    &:after {
      content: '';
      display: block;
      width: 12px;
      height: 20px;
      background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="11.375" height="19.719" viewBox="0 0 11.375 19.719"><path id="パス_458" data-name="パス 458" d="M1.515,0,0,1.515,8.344,9.859,0,18.2l1.516,1.516,9.859-9.859Z" transform="translate(0 0)"/></svg>');
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      position: absolute;
      right: 15px;
      top: 50%;
      margin-top: -10px;
      transition: right 0.15s ease-out;
    }
  }
`;

const CareLinkIcon = styled.div`
  width: 24px;
  height: 24px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g id="長方形_677" data-name="長方形 677" fill="none" stroke="%23000" stroke-width="1"><rect width="24" height="24" rx="2" stroke="none"/><rect x="0.5" y="0.5" width="23" height="23" rx="1.5" fill="none"/></g></svg>');

  &.active {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g id="グループ_1114" data-name="グループ 1114" transform="translate(-224 -188)"><g id="長方形_677" data-name="長方形 677" transform="translate(224 188)" fill="none" stroke="%23000" stroke-width="1"><rect width="24" height="24" rx="2" stroke="none"/><rect x="0.5" y="0.5" width="23" height="23" rx="1.5" fill="none"/></g><path id="パス_205" data-name="パス 205" d="M3333.988,3356.709l6.226,6.131,7.788-10.1" transform="translate(-3104.996 -3157.788)" fill="none" stroke="%23000" stroke-width="2"/></g></svg>');
  }

`;

const NewsSectionTitle = styled.div`
  font-size: 14px;
  line-height: 19px;
  font-weight: bold;
  margin-bottom: 20px;
`;

const LatestNewsSectionElm = styled.div`
  margin-bottom: 40px;

  & > a {
    display: flex;
    color: #000000;
    background-color: #ffffff;
    text-decoration: none;
    align-items: center;
    border: 1px solid #000000;
    border-radius: 2px;
    transition: background-color 0.15s linear;

    @media ${config.layout.wide} {
      width: 50%;
    }

    .content {
      flex: 1 1 auto;
      margin: 20px 15px 30px 22px;

      .date {
        font-weight: bold;
        font-size: 16px;
        line-height: 21px;
      }

      .title {
        margin-top: 11px;
        font-size: 16px;
        line-height: 21px;
        font-weight: bold;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }

    @media ${config.layout.wide} {
      &:hover {
        background-color: #000000;

        .content {
          color: #ffffff;
        }
      }
    }

    &:after {
      flex: 0 0 auto;
      content: '';
      display: block;
      width: 12px;
      height: 20px;
      background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="11.375" height="19.719" viewBox="0 0 11.375 19.719"><path id="パス_458" data-name="パス 458" d="M1.515,0,0,1.515,8.344,9.859,0,18.2l1.516,1.516,9.859-9.859Z" transform="translate(0 0)" fill="%23000" /></svg>');
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      margin-right: 15px;
    }
  }
`;

const MenuSectionTitle = styled.div`
  font-size: 14px;
  line-height: 19px;
  font-weight: bold;
  margin-bottom: 20px;

  @media ${config.layout.wide} {
    font-size: 16px;
    line-height: 21px;
  }
`;

const MenuSectionElm = styled.div`
`;

const MenuSectionLinkItems = styled.div`
  border-top: 1px solid #000000;

  @media ${config.layout.wide} {
    border-top: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  & > a {
    height: 84px;
    border-bottom: 1px solid #000000;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding-left: 5px;

    @media ${config.layout.wide} {
      width: calc(50% - 15px);
      flex: 0 0 auto;

      &:nth-child(1), &:nth-child(2) {
        border-top: 1px solid #000000;
      }

      &:hover {
        &:after {
          margin-right: 0;
        }
      }
    }

    span {
      font-weight: bold;
      color: #000000;
      font-size: 32px;
      flex: 1 1 auto;
    }

    &:after {
      flex: 0 0 auto;
      content: '';
      display: block;
      width: 12px;
      height: 20px;
      background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="11.375" height="19.719" viewBox="0 0 11.375 19.719"><path id="パス_458" data-name="パス 458" d="M1.515,0,0,1.515,8.344,9.859,0,18.2l1.516,1.516,9.859-9.859Z" transform="translate(0 0)" fill="%23000" /></svg>');
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      margin-right: 15px;
      transition: margin-right 0.15s ease-out;
    }
  }
`;

const SmallLinks = styled.div`
  margin-top: 40px;
  display: flex;
  align-items: center;
  height: 40px;
  //background-color: pink;
  justify-content: space-around;
  position: relative;

  @media ${config.layout.wide} {
    //width: 200px;
    justify-content: left;
  }
  
  & > div {
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    @media ${config.layout.wide} {
      width: auto;
      padding-left: 20px;
      padding-right: 20px;
    }
    a {
      text-decoration: none;
      font-weight: bold;
      color: #000000;
      font-size: 20px;
    }
    &:first-child {
      position: relative;
      &:before {
        content: '';
        display: block;
        position: absolute;
        width: 1px;
        height: 100%;
        right: 0;
        top: 0;
        background-color: #000000;
      }

      @media ${config.layout.wide} {
        padding-left: 5px;
      }
    }
  }
  

  
`;

function LoggedInHeader({closeModal}) {
  const location = useLocation();
  if (location.pathname === '/') {
    return (
        <LogoWrap className={'logo-wrap'}>
          <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                window.location.reload();
              }}
              className="header-logo link"
          >
            <Logo className="sitelogo"></Logo>
          </a>
        </LogoWrap>
    );
  }
  return (
      <LogoWrap className={'logo-wrap'}>
        <LinkWrap to="/" className="header-logo link" closeModal={closeModal}>
          <Logo className="sitelogo"></Logo>
        </LinkWrap>
      </LogoWrap>
  );
}

const RightItems = styled.div`
  display: flex;
  align-items: center;
  gap: 0px;
  flex: 1 1 auto;
  background-color: #F8F8F8;
  height: 100%;
  min-width: 0;

  @media ${config.layout.wide} {
    position: absolute;
    right: 0;
  }
`;






function LinkWrap({to, closeModal, children, ...props}) {
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname === to) {
    return (
        <a
            {...props}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              closeModal();
              window.location.reload();
            }}
        >
          {children}
        </a>
    );
  }

  const onClick = (e) => {
    e.preventDefault();
    closeModal();
    navigate(to);
  };

  return (
      <a href="#" onClick={onClick} {...props}>
        {children}
      </a>
  );
}

function NewsSection({closeModal}) {
  const app = useApp();

  if (!app.state.latest_news) {
    return '';
  }

  const news = app.state.latest_news;

  return (
      <LatestNewsSectionElm>
        <NewsSectionTitle>News</NewsSectionTitle>
        <LinkWrap to="/news/" className={'latest-news-link'}
                  closeModal={closeModal}>
          <div className="content">
            <span className="date">{moment(news.display_datetime).
                utc().
                format('YYYY/MM/DD')}</span>
            <div className="title">{news.title_en}</div>
          </div>
        </LinkWrap>
      </LatestNewsSectionElm>
  );
}

function MenuSection({closeModal}) {

  return (
      <MenuSectionElm>
        <MenuSectionTitle>Menu</MenuSectionTitle>
        <MenuSectionLinkItems>
          <LinkWrap to={'/'}
                    closeModal={closeModal}><span>Dashboard</span></LinkWrap>
          <LinkWrap to={'/chart/'}
                    closeModal={closeModal}><span>Chart</span></LinkWrap>
          <LinkWrap to={'/venue-info/'}
                    closeModal={closeModal}><span>Venue</span></LinkWrap>
          <LinkWrap to={'/devices/'} closeModal={closeModal}><span>Device</span></LinkWrap>
          <LinkWrap to={'/reporting-status/'} closeModal={closeModal}><span>Reporting status</span></LinkWrap>
          <LinkWrap to={'/news/'}
                    closeModal={closeModal}><span>News</span></LinkWrap>
          <LinkWrap to={'/manual/'} closeModal={closeModal}><span>Manual</span></LinkWrap>
          <LinkWrap to={'/care/about/'} closeModal={closeModal}><span>KUVO Care</span></LinkWrap>
        </MenuSectionLinkItems>
      </MenuSectionElm>
  );
}

function MenuPanel({isOpen, closeModal}) {

  const auth = useAuth();
  const venue = auth.state.venue || null;

  return (
      <MenuPanelElm className={isOpen ? 'open' : 'closed'}>
        <PanelContents>
          <VenueCode>KUVO ID : {venue?.venue_code || ''}</VenueCode>
          <VenueInfoArea>
            <div className={'name'}>
              <div className={'label'}>Venue Name</div>
              <div className={'venue-name'}>{venue?.name || ''}</div>
            </div>
            <LinkWrap to={'/care/about/'} closeModal={closeModal} className={'care-link'}>
              <CareLinkIcon className={`care-link-icon ${venue?.care?.status
                  ? 'active'
                  : 'inactive'}`}/>
              <span>KUVO Care</span>
            </LinkWrap>
          </VenueInfoArea>
          <NewsSection closeModal={closeModal}/>
          <MenuSection closeModal={closeModal}/>
          <SmallLinks>
            <div>
              <LinkWrap to={'/contact/'}
                        closeModal={closeModal}>Contact</LinkWrap>
            </div>
            <div>
              <LinkWrap to={'/faq/'} closeModal={closeModal}>FAQ</LinkWrap>
            </div>
          </SmallLinks>
          <LogoutButtonArea>
            <LogoutButton
                className={'dark-button'}

                onClick={(e)=>{
              closeModal();
              window.logged_out_now = true;
              auth.signout();
            }}><span>Logout</span></LogoutButton>
          </LogoutButtonArea>
        </PanelContents>
      </MenuPanelElm>
  );
}

function ATCGlobalHeader() {

  return (
      <div id={"atc-global-header"}>
        <a id="atc-global-link" href={"https://alphatheta.com/"} target={"_blank"}>AlphaTheta</a>
      </div>
  );
}

export default function HeaderNav() {
  const auth = useAuth();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);

  const onLogoutClick = () => {
    window.logged_out_now = true;
    auth.signout();
  };

  const onManualClick = () => {
    navigate('/manual/');
  };

  const onBurgerButtonClicked = () => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    let newStatus = !isOpen;
    setIsOpen(newStatus);
  };

  const closeModal = () => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    setIsOpen(0);
  };

  return (
      <>
        <ATCGlobalHeader/>
      <header id="nav-header" className={isOpen ? 'open' : 'closed'}>
        <HeaderInner>
          {auth.isLoggedIn() ? (
              <LoggedInHeader closeModal={closeModal}/>
          ) : (
              <>
                <NotLoggedInHeader/>
                <LoggedInHeader closeModal={closeModal}/>
              </>
          )}

          {auth.isLoggedIn() ? (
              <RightItems>
                <HeaderVenueNameArea>
                  {auth.state?.venue?.name || 'null'}
                </HeaderVenueNameArea>
                <HeaderBurgerButton className={isOpen ? 'open' : 'closed'}
                                    onClick={onBurgerButtonClicked}>
                  <div className={'icon'}/>
                </HeaderBurgerButton>
              </RightItems>
          ) : (
              ''
          )}
        </HeaderInner>

        {auth.isLoggedIn() ? (
            <MenuPanel isOpen={isOpen} closeModal={closeModal}/>
        ) : ('')
        }
      </header>
      </>
  );
}
